module.exports = __webpack_public_path__ + "static/media/DSC_1330-Pano.a6ab9978.jpg";